import { initialize as initializeDevtoolsBackend } from 'react-devtools-inline/backend';

initializeDevtoolsBackend(window);
